import HorizontalImageCard from "../elements/horizontalImageCard";


export default function CarouselCard5() {

    return (
        <div className="flex">

            <div className="">
                <div className="grid grid-cols-1 md:grid-cols-2 md:w-full mx-12">
                    <div className="swiper-slide card-slide md:px-5 card-slide-left ">

                        <HorizontalImageCard
                            imageURL="https://lh4.googleusercontent.com/fkUViOD4bHqvWB7V0jZcvgmGIig15rYREotITeyMHkZLdXV8NfyqS6kWYfEPTFUsDYtlI3MwYeWRml_-KFu4--9qrmZf4UJEMrb4ua-2VmJdiLa2FErkPFEZLXkPX8uGsD1FhLln"
                            imageAlt="Professional Communicator"
                            title="Speaking the Language of Business"
                            blurb="Externs develop the ability to communicate professionally and master the language that drives real‑world collaboration."
                        />
                    </div>
                    <div className="swiper-slide card-slide md:px-5 card-slide-center  ">

                        <HorizontalImageCard
                            imageURL="https://res.cloudinary.com/aenetworks/image/upload/c_fill,w_3840,h_2560,g_auto/dpr_auto/f_auto/q_auto:eco/v1/GettyImages-113448548-2?_a=BAVAZGB00"
                            imageAlt="Extern Academy Teamwork"
                            title="Real Problem Solvers"
                            blurb="Every student is vetted to ensure each extern is an ambitious critical thinker and an avid problem solver."
                        />
                    </div>


                </div>

            </div>
        </div>
    )
}